export default function sketch(p) {

    let visualization_data = [];  //[[frame_length,["1,1,1;2,2,2;3,3,3..."],[frame_length,["1,1,1;2,2,2;3,3,3..."]]
    let valid;              //boolean to filter out sitations where received visualization_data is empty
    let total_animation_duration = 0; //sum of all the frame durations
    let start_time;         //timestamp marking the start of the animation
    let initial = true;
    let duration_and_frame;
    let frame_counter = 0;
    let pixel_size = 40;
    let inter_pixel_padding = 2;
    let canvas_size = 354;
    let loopCountStop = 0; //counter to keep track of loop count from props
    let loopCount = 0; //for props.loop_count when custom draw runs
    let jsonFrames = 0; //for props.json so we can use the integer outside custom draw function 
    let pauseCode = false;
    //starting point of the



    p.setup = () => {

        p.createCanvas(canvas_size, canvas_size) //keep in draw, otherwise different sized canvases can get mixed
        p.noStroke()
        p.background('#343434')

        if(canvas_size === 354){

            p.textSize(18)
            p.fill(0)
            let row_nr_startx = 34
            let row_nr_starty = 15
            //column numbers
            for (let nr = 0; nr < 8; nr++) {
                p.text(nr.toString(), row_nr_startx,row_nr_starty)
                row_nr_startx = row_nr_startx + pixel_size + inter_pixel_padding
            }
            // //row numbers
            let col_nr_startx = 5
            let col_nr_starty = 44
            for (let nr = 0; nr < 8; nr++) {
                p.text(nr.toString(),col_nr_startx, col_nr_starty)
                col_nr_starty = col_nr_starty + pixel_size + inter_pixel_padding
            }


        }
    }

    p.draw = () => {

        

        let x = 0
        let y = 0

        if (canvas_size !== 354) {
            //explore view
            p.createCanvas(canvas_size, canvas_size)

        }
        else {
            //making room for the numbers
            x = 20
            y = 20

        }



        let item = 0


        if (valid) {
            if (initial) {
                duration_and_frame = p.getframe()
                initial = false
                frame_counter = (frame_counter + 1) % visualization_data.length
            }
        }



        for (let row = 0; row < 8; row++) {
            for (let col = 0; col < 8; col++) {

                if (valid) {
                    if (duration_and_frame[1][item] !== "0") {
                        let colors = duration_and_frame[1][item].split(',')
                        //console.log("Color: ", frame[item])

                        p.fill(colors[0], colors[1], colors[2])
                    }
                    else { p.fill(0) }
                }
                else { p.fill(0) }

                p.rect(x, y, pixel_size, pixel_size, 3)
                x = x + pixel_size + inter_pixel_padding
                item = item + 1
            }
            y = y + pixel_size + inter_pixel_padding
            x = (canvas_size === 354 ? 20 : 0)
        }

        if (valid) {
            if (pauseCode) { //for the pause animation button
                p.noLoop();
            }
            if (!pauseCode) {
                p.loop();
            }

            let c = new Date()
            let current_time = c.getTime()
            let time = (current_time - start_time)

            if (time >= duration_and_frame[0]) {
                duration_and_frame = p.getframe()
                frame_counter = (frame_counter + 1) % visualization_data.length
                
            }
            if (loopCount > 0 && loopCountStop === jsonFrames * loopCount+1) { //stop looping if props.loop_count is met
                p.noLoop();
            }
        }

    }

    p.myCustomRedrawAccordingToNewPropsHandler = (props) => {

        //reset
        total_animation_duration = 0;
        visualization_data = [];
        initial = true;
        frame_counter = 0;
        canvas_size = 354;
        valid = false;
        jsonFrames = props.frames_json.length;
        loopCountStop = 0; //reset this if charm is updated and run is clicked by user
        if (props.loopCount) {
            loopCount = props.loopCount;
        }
        pauseCode = props.pauseCode;
        p.loop()

        //reading the received json into data visualization in the correct format 
        if (props.frames_json !== "") {

                for (let i = 0; i < props.frames_json.length; i++) {
                    if (props.frames_json[i].frame) {
    
                        let frame = props.frames_json[i].frame
                        let duration = props.frames_json[i].duration
    
                        if (frame !== " ") {
                            let stuff = frame.split(';')
                            valid = true
                            total_animation_duration = total_animation_duration + duration
                            visualization_data.push([duration, stuff])
                            // console.log("TEST DATA: ", duration, stuff)
                        }
                        else {
                            valid = false
                        }
                    }
    
                }

            if (props.pixel_size) {
                pixel_size = props.pixel_size
                canvas_size = 8 * pixel_size + 7 * inter_pixel_padding
            }
            
        }

    }

    p.getframe = () => {

        
        let d = new Date()      //time structure
        start_time = d.getTime()
        loopCountStop++ //count frames from props
        
        return visualization_data[frame_counter];

    }





}

